import React from "react";
import classNames from "classnames";
import { Button } from "./Button";

const Form = ({ className, children, ...props }) => {
  return (
    <form className={classNames(className, "block")} {...props}>
      {children}
    </form>
  );
};

const InputRow = ({ className, children, ...props }) => {
  return (
    <div className={classNames(className, "mb-5")} {...props}>
      {children}
    </div>
  );
};

const InputRowDivider = ({ className, ...props }) => {
  return (
    <hr className={classNames(className, "my-3")} {...props} />
  );
};

const Label = ({ label, required, className, children, ...props }) => {
  return (
    <label className={classNames(className, "block font-bold")} {...props}>
      {label}{required && "*"}
      {children}
    </label>
  );
};

const CheckboxesLabel = ({ label, required, className, ...props }) => {
  return (
    <div className={classNames(className, "mb-1")} {...props}>
      {label}{required && "*"}
    </div>
  );
};

const CheckboxLabel = ({ label, className, children, ...props }) => {
  return (
    <label className={classNames(className, "mb-1 block")} {...props}>
      {children}{" "}{label}
    </label>
  );
};
const InputTextBox = React.forwardRef(({ as: Component = "input", className, ...props }, ref) => {
  return (
    <Component ref={ref} className={classNames(className, "mt-1 p-2 block border border-gray-300 w-full")} {...props} />
  );
});

const InputSelect = React.forwardRef(({ as: Component = "select", className, ...props }, ref) => {
  return (
    <Component ref={ref} className={classNames(className, "mt-1 p-2 bg-white block border border-gray-300 block w-full")} {...props} />
  );
});

const InputTextArea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <InputTextBox ref={ref} as="textarea" className={classNames(className, "h-[120px] sm:h-[250px] resize-none")} {...props} />
  );
});

const InputError = ({ className, children, ...props }) => {
  return (
    <div className={classNames(className, "text-red-700 mt-1")} {...props}>{children}</div>
  );
};

const SubmitError = ({ className, children, ...props }) => {
  return (
    <div className={classNames(className, "text-red-700 my-2")} {...props}>{children}</div>
  );
};

const SubmitSuccess = ({ className, children, ...props }) => {
  return (
    <div className={classNames(className, "text-green-700 my-2")} {...props}>{children}</div>
  );
};

const SubmitButton = ({loading, children, ...props}) => {
  return (
    <Button disabled={loading} type="submit" className="w-full disabled:bg-gray-600" {...props}>
      {loading && "Loading"}
      {!loading && children}
    </Button>
  );
};

export {
  Form,
  InputRow,
  InputRowDivider,
  Label,
  InputTextBox,
  InputSelect,
  InputTextArea,
  CheckboxesLabel,
  CheckboxLabel,
  InputError,
  SubmitError,
  SubmitSuccess,
  SubmitButton,
};
